import { render, staticRenderFns } from "./StoryboardSoundGenerate.vue?vue&type=template&id=6517b8ae&scoped=true"
import script from "./StoryboardSoundGenerate.vue?vue&type=script&lang=js"
export * from "./StoryboardSoundGenerate.vue?vue&type=script&lang=js"
import style0 from "./StoryboardSoundGenerate.vue?vue&type=style&index=0&id=6517b8ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6517b8ae",
  null
  
)

export default component.exports